"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-three/sections/footerSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type FooterSection66sItem = {
    key: Key | null | undefined;
    /** Detected variants: "Company" | "For Patients" */
    h30Text: ReactNode;
    /** Detected variants: "col-lg-6 col-sm-6" */
    className?: string;
    /** Detected variants: "footer-widget footer-menu" */
    div0ClassName?: string;
    /** Detected variants: "footer-title" */
    h30ClassName?: string;
    /** Detected variants: "fa-solid fa-circle" */
    i0ClassName?: string;
    footerWidgetItems?: FooterSectionUlsItem[];
};

type FooterSectionUlsItem = {
    key: Key | null | undefined;
    /** Detected variants: "About" | "Contact Us" | "Hospitals" | "Specialities" | "Clinics" | "Braces & Aligners" | "Cosmetic Dentistry" | "Root Canal Specialist" | "Teeth Cleaning & Care" | "General Dentistry" */
    link0Text: ReactNode;
    /** Detected variants: "all_routes.aboutUs" | "all_routes.contactUs" | "all_routes.hospitals" | "all_routes.speciality" | "all_routes.clinics" | "#" */
    href: string;
};

type FooterSectionServicesSlidesItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/icons/footer-icon-1.svg" | "/Templates/Doccure/img/icons/footer-icon-2.svg" */
    src: string;
    /** Detected variants: "services-slide" */
    className?: string;
    /** Detected variants: "Dental Clinic" */
    h20Text?: ReactNode;
    /** Detected variants: "" */
    alt?: string;
    /** Detected variants: "img-fluid img-1" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "" */
    h20Expr2?: ReactNode;
};

type FooterSectionDivsItem = {
    key: Key | null | undefined;
    /** Detected variants: "fa-brands fa-facebook" | "fa-brands fa-x-twitter" | "fa-brands fa-instagram" | "fa-brands fa-linkedin" */
    className: string;
    /** Detected variants: "#" */
    href?: string;
};
export type HomeThreeFooterSectionGeneratedProps = {
    divDiv0H30H3Props?: Partial<ComponentProps<"h3">> | ((item: FooterSection66sItem) => Partial<ComponentProps<"h3">>);
    divH20H2Props?: Partial<ComponentProps<"h2">> | ((item: FooterSectionServicesSlidesItem) => Partial<ComponentProps<"h2">>);
    divH20ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: FooterSectionServicesSlidesItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    footerDiv0Div0Div0ClassName?: string;
    /** Default: "#" */
    footerDiv0Div0Div0Div0Div0Div0Link0LinkHref?: string;
    footerDiv0Div0Div0Div0Div0Div0Link0LinkVisible?: boolean;
    footerDiv0Div0Div0Div0Div0Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0Div0Div0Div0Div0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Get Started" */
    footerDiv0Div0Div0Div0Div0Div0Link0Span0SpanText?: ReactNode;
    /** Default: "Looking for Professional" */
    footerDiv0Div0Div0Div0Div0H20H2Text?: ReactNode;
    /** Default: "Dentist for" */
    footerDiv0Div0Div0Div0Div0H20H2Text2?: ReactNode;
    footerDiv0Div0Div0Div0Div0H20H2Visible?: boolean;
    footerDiv0Div0Div0Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0Div0Div0Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Consultation" */
    footerDiv0Div0Div0Div0Div0H20Span0SpanText?: ReactNode;
    footerDiv0Div0Div0Div1Div0ClassName?: string;
    footerDiv1Div0Div0Div0ClassName?: string;
    /** Default: "© 2025 Doccure. All rights reserved." */
    footerDiv1Div0Div0Div0Div0Div0P0PText?: ReactNode;
    /** Default: "element" */
    footerImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/footer-element-1.png" */
    footerImageWithBasePath0ImageSrc?: string;
    footerImageWithBasePath0ImageVisible?: boolean;
    footerImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "element" */
    footerImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/footer-bg-1.png" */
    footerImageWithBasePath1ImageSrc?: string;
    footerImageWithBasePath1ImageVisible?: boolean;
    footerImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "fade-up" */
    footerSection0SectionDataAos?: string;
    /** Default: "left" */
    footerSection0Div0DivDataDirection?: string;
    /** Default: "slow" */
    footerSection0Div0DivDataSpeed?: string;
    liLink0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUlsItem) => Partial<ComponentProps<typeof SmartLink>>);
    linkLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionDivsItem) => Partial<ComponentProps<typeof SmartLink>>);
    footerSection66s: FooterSection66sItem[];
    footerSectionServicesSlides: FooterSectionServicesSlidesItem[];
    footerSectionDivs: FooterSectionDivsItem[];
    footerSection66sItemWrapper?: (item: FooterSection66sItem, content: ReactNode) => ReactNode;
    footerSection66sRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSection66sH3Visible?: boolean;
    footerSection66sH3Renderer?: (item: FooterSection66sItem, defaultNode: ReactNode) => ReactNode;
    footerSection66sH3Props?: Partial<ComponentProps<"h3">> | ((item: FooterSection66sItem) => Partial<ComponentProps<"h3">>);
    footerSectionUlsItemWrapper?: (item: FooterSectionUlsItem, content: ReactNode) => ReactNode;
    footerSectionUlsRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionUlsLinkVisible?: boolean;
    footerSectionUlsLinkRenderer?: (item: FooterSectionUlsItem, defaultNode: ReactNode) => ReactNode;
    footerSectionUlsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUlsItem) => Partial<ComponentProps<typeof SmartLink>>);
    footerSectionServicesSlidesItemWrapper?: (item: FooterSectionServicesSlidesItem, content: ReactNode) => ReactNode;
    footerSectionServicesSlidesRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionServicesSlidesImageVisible?: boolean;
    footerSectionServicesSlidesImageRenderer?: (item: FooterSectionServicesSlidesItem, defaultNode: ReactNode) => ReactNode;
    footerSectionServicesSlidesH2Visible?: boolean;
    footerSectionServicesSlidesH2Renderer?: (item: FooterSectionServicesSlidesItem, defaultNode: ReactNode) => ReactNode;
    footerSectionServicesSlidesImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: FooterSectionServicesSlidesItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    footerSectionServicesSlidesH2Props?: Partial<ComponentProps<"h2">> | ((item: FooterSectionServicesSlidesItem) => Partial<ComponentProps<"h2">>);
    footerSectionDivsItemWrapper?: (item: FooterSectionDivsItem, content: ReactNode) => ReactNode;
    footerSectionDivsRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionDivsLinkVisible?: boolean;
    footerSectionDivsLinkRenderer?: (item: FooterSectionDivsItem, defaultNode: ReactNode) => ReactNode;
    footerSectionDivsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionDivsItem) => Partial<ComponentProps<typeof SmartLink>>);
};

const HomeThreeFooterSectionGenerated: FC<HomeThreeFooterSectionGeneratedProps> = ({
    footerDiv0Div0Div0Div0Div0Div0Link0LinkHref = "#",
    footerDiv0Div0Div0Div0Div0Div0Link0LinkVisible,
    footerDiv0Div0Div0Div0Div0Div0Link0LinkRenderer,
    footerDiv0Div0Div0Div0Div0Div0Link0LinkProps,
    footerDiv0Div0Div0Div0Div0Div0Link0Span0SpanText = "Get Started",
    footerDiv0Div0Div0Div0Div0H20H2Text = "Looking for Professional",
    footerDiv0Div0Div0Div0Div0H20H2Text2 = "Dentist for",
    footerDiv0Div0Div0Div0Div0H20H2Visible,
    footerDiv0Div0Div0Div0Div0H20H2Renderer,
    footerDiv0Div0Div0Div0Div0H20H2Props,
    footerDiv0Div0Div0Div0Div0H20Span0SpanText = "Consultation",
    footerDiv1Div0Div0Div0Div0Div0P0PText = "© 2025 Doccure. All rights reserved.",
    footerImageWithBasePath0ImageAlt = "element",
    footerImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/footer-element-1.png",
    footerImageWithBasePath0ImageVisible,
    footerImageWithBasePath0ImageRenderer,
    footerImageWithBasePath0ImageProps,
    footerImageWithBasePath1ImageAlt = "element",
    footerImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/footer-bg-1.png",
    footerImageWithBasePath1ImageVisible,
    footerImageWithBasePath1ImageRenderer,
    footerImageWithBasePath1ImageProps,
    footerSection0Div0DivDataDirection = "left",
    footerSection0Div0DivDataSpeed = "slow",
    footerSection0SectionDataAos = "fade-up",
    divDiv0H30H3Props,
    divH20H2Props,
    divH20ImageWithBasePath0ImageProps,
    liLink0LinkProps,
    linkLinkProps,
    footerDiv0Div0Div0ClassName,
    footerDiv0Div0Div0Div1Div0ClassName,
    footerDiv1Div0Div0Div0ClassName,
    footerSection66s,
    footerSectionServicesSlides,
    footerSectionDivs,
    footerSection66sItemWrapper,
    footerSection66sRenderer,
    footerSection66sH3Visible,
    footerSection66sH3Renderer,
    footerSection66sH3Props,
    footerSectionUlsItemWrapper,
    footerSectionUlsRenderer,
    footerSectionUlsLinkVisible,
    footerSectionUlsLinkRenderer,
    footerSectionUlsLinkProps,
    footerSectionServicesSlidesItemWrapper,
    footerSectionServicesSlidesRenderer,
    footerSectionServicesSlidesImageVisible,
    footerSectionServicesSlidesImageRenderer,
    footerSectionServicesSlidesH2Visible,
    footerSectionServicesSlidesH2Renderer,
    footerSectionServicesSlidesImageProps,
    footerSectionServicesSlidesH2Props,
    footerSectionDivsItemWrapper,
    footerSectionDivsRenderer,
    footerSectionDivsLinkVisible,
    footerSectionDivsLinkRenderer,
    footerSectionDivsLinkProps,
}) => {
    return (
        <footer className="footer-three">
            <div className="footer-top">
                <div className="container">
                    <div className={footerDiv0Div0Div0ClassName ?? "row"}>
                        <div className="col-md-6">
                            <div className="footer-title">
                                {renderNode(footerDiv0Div0Div0Div0Div0H20H2Visible, footerDiv0Div0Div0Div0Div0H20H2Renderer, (
                                    <h2 className="section-title" {...(footerDiv0Div0Div0Div0Div0H20H2Props ?? {})}>
                                        {footerDiv0Div0Div0Div0Div0H20H2Text}
                                        <br />
                                        {footerDiv0Div0Div0Div0Div0H20H2Text2}
                                        {" "}
                                        <span>{footerDiv0Div0Div0Div0Div0H20Span0SpanText}</span>
                                    </h2>
                                ))}
                                <div className="more-btn">
                                    {renderNode(footerDiv0Div0Div0Div0Div0Div0Link0LinkVisible, footerDiv0Div0Div0Div0Div0Div0Link0LinkRenderer, (
                                        <SmartLink href={footerDiv0Div0Div0Div0Div0Div0Link0LinkHref} className="btn btn-primary theme-2-btn" {...(footerDiv0Div0Div0Div0Div0Div0Link0LinkProps ?? {})}>
                                            <span>
                                                {footerDiv0Div0Div0Div0Div0Div0Link0Span0SpanText}
                                                <span className="icon">
                                                    <i className="isax isax-arrow-up-34" />
                                                </span>
                                            </span>
                                        </SmartLink>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className={footerDiv0Div0Div0Div1Div0ClassName ?? "row footer-row-top"}>
                                {renderCollectionNode(
                                    footerSection66s,
                                    (item: FooterSection66sItem) => (
                                        <div className={item.className ?? "col-lg-6 col-sm-6"} key={item.key}>
                                            <div className={item.div0ClassName ?? "footer-widget footer-menu"}>
                                                {renderItemNode(footerSection66sH3Visible, footerSection66sH3Renderer, item, (
                                                    <h3 className={item.h30ClassName ?? "footer-title"} {...(typeof footerSection66sH3Props === "function" ? footerSection66sH3Props(item) : (footerSection66sH3Props ?? {}))} {...(typeof divDiv0H30H3Props === "function" ? divDiv0H30H3Props(item) : (divDiv0H30H3Props ?? {}))}>
                                                        <i className={item.i0ClassName ?? "fa-solid fa-circle"} />
                                                        {item.h30Text}
                                                    </h3>
                                                ))}
                                                <ul>
                                                    {renderCollectionNode(
                                                        item.footerWidgetItems ?? [],
                                                        (item: FooterSectionUlsItem) => (
                                                            <li key={item.key}>
                                                                {renderItemNode(footerSectionUlsLinkVisible, footerSectionUlsLinkRenderer, item, (
                                                                    <SmartLink href={item.href} {...(typeof footerSectionUlsLinkProps === "function" ? footerSectionUlsLinkProps(item) : (footerSectionUlsLinkProps ?? {}))} {...(typeof liLink0LinkProps === "function" ? liLink0LinkProps(item) : (liLink0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                                ))}
                                                            </li>
                                                        ),
                                                        footerSectionUlsItemWrapper,
                                                        footerSectionUlsRenderer
                                                    )}
                                                </ul>
                                            </div>
                                        </div>
                                    ),
                                    footerSection66sItemWrapper,
                                    footerSection66sRenderer
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <section className="slider-section slider-section-three position-relative aos" data-aos={footerSection0SectionDataAos}>
                <div className="horizontal-slide slide-three d-flex" data-direction={footerSection0Div0DivDataDirection} data-speed={footerSection0Div0DivDataSpeed}>
                    <div className="slide-list d-flex gap-4">
                        {renderCollectionNode(
                            footerSectionServicesSlides,
                            (item: FooterSectionServicesSlidesItem) => (
                                <div className={item.className ?? "services-slide"} key={item.key}>
                                    {renderItemNode(footerSectionServicesSlidesH2Visible, footerSectionServicesSlidesH2Renderer, item, (
                                        <h2 {...(typeof footerSectionServicesSlidesH2Props === "function" ? footerSectionServicesSlidesH2Props(item) : (footerSectionServicesSlidesH2Props ?? {}))} {...(typeof divH20H2Props === "function" ? divH20H2Props(item) : (divH20H2Props ?? {}))}>
                                            {item.h20Text ?? "Dental Clinic"}
                                            {" "}
                                            {renderItemNode(footerSectionServicesSlidesImageVisible, footerSectionServicesSlidesImageRenderer, item, (
                                                <SmartImage src={item.src} alt={item.alt ?? ""} className={item.imageWithBasePath0ClassName ?? "img-fluid img-1"} {...(typeof footerSectionServicesSlidesImageProps === "function" ? footerSectionServicesSlidesImageProps(item) : (footerSectionServicesSlidesImageProps ?? {}))} {...(typeof divH20ImageWithBasePath0ImageProps === "function" ? divH20ImageWithBasePath0ImageProps(item) : (divH20ImageWithBasePath0ImageProps ?? {}))} />
                                            ))}
                                            {" "}
                                        </h2>
                                    ))}
                                </div>
                            ),
                            footerSectionServicesSlidesItemWrapper,
                            footerSectionServicesSlidesRenderer
                        )}
                    </div>
                </div>
            </section>
            <div className="footer-bottom">
                <div className="container">
                    <div className="copyright">
                        <div className={footerDiv1Div0Div0Div0ClassName ?? "row justify-content-center"}>
                            <div className="col-sm-6 col-lg-6">
                                <div className="copyright-text">
                                    <p className="mb-0">{footerDiv1Div0Div0Div0Div0Div0P0PText}</p>
                                </div>
                            </div>
                            <div className="col-sm-6 col-lg-6">
                                <div className="social-icon">
                                    {renderCollectionNode(
                                        footerSectionDivs,
                                        (item: FooterSectionDivsItem) => (
                                            renderItemNode(footerSectionDivsLinkVisible, footerSectionDivsLinkRenderer, item, (
                                                <SmartLink href={item.href ?? "#"} {...(typeof footerSectionDivsLinkProps === "function" ? footerSectionDivsLinkProps(item) : (footerSectionDivsLinkProps ?? {}))} {...(typeof linkLinkProps === "function" ? linkLinkProps(item) : (linkLinkProps ?? {}))} key={item.key}>
                                                    <i className={item.className} />
                                                </SmartLink>
                                            ))
                                        ),
                                        footerSectionDivsItemWrapper,
                                        footerSectionDivsRenderer
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {renderNode(footerImageWithBasePath0ImageVisible, footerImageWithBasePath0ImageRenderer, (
                <SmartImage src={footerImageWithBasePath0ImageSrc} alt={footerImageWithBasePath0ImageAlt} className="img-fluid img-1" {...(footerImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderNode(footerImageWithBasePath1ImageVisible, footerImageWithBasePath1ImageRenderer, (
                <SmartImage src={footerImageWithBasePath1ImageSrc} alt={footerImageWithBasePath1ImageAlt} className="img-fluid img-2" {...(footerImageWithBasePath1ImageProps ?? {})} />
            ))}
        </footer>
    );
};

export default HomeThreeFooterSectionGenerated;
